<template>
    <div>
        <div v-if="!textOnly && !loader" :class="divClass">
            <v-btn v-bind="$attrs" @click="download"
                >{{ text }}
                <v-icon v-if="icon" right :dark="dark">{{ mdiCloudDownload }}</v-icon>
            </v-btn>
        </div>
        <div v-if="loader" :class="divClass">
            <v-btn
                class="mt-5"
                v-bind="$attrs"
                outlined
                :loading="loading"
                :disabled="loading || disabled"
                @click="download"
            >
                <span>{{ text }}<v-icon v-if="icon" right>{{ mdiCloudDownload }}</v-icon></span>
            </v-btn>
        </div>
        <div v-if="textOnly && !loader" :class="divClass">
            <a :style="textStyle" @click="download(), (loading = true)">{{ text }}</a>
        </div>
    </div>
</template>

<script>
import XLSX from 'xlsx'
import { mdiCloudDownload } from '@mdi/js'

export default {
    name: `DownloadFileXlsx`,
    props: {
        icon: {
            type: Boolean,
            default: false
        },

        divClass: {
            type: String,
            default: `text-xs-center`
        },
        loader: {
            type: Boolean,
            default: false
        },
        textOnly: {
            type: Boolean,
            default: false
        },
        tableArray: {
            type: Array,
            required: true
        },
        tableHeader: {
            type: Array,
            required: true
        },
        fileName: {
            type: String,
            default: `download.xlsx`
        },
        text: {
            type: String,
            default: `Download File`
        },
        textStyle: {
            type: String,
            default: ``
        },
        dataFunc: {
            type: Function,
            default: undefined
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            loading: false,
            apiResponse: {
                data: null
            },
            mdiCloudDownload
        }
    },
    methods: {
        getValue(obj, path) {
            // in case the value is nested
            return path.split('.').reduce((acc, key) => acc?.[key], obj)
        },
        async download() {
            try {
                this.loading = true
                if (this.dataFunc) await this.dataFunc()
                let xlsxData = [this.tableHeader.map((header) => header.text)]
                if (this.tableArray.length > 0) {
                    // convert data into a new array
                    xlsxData = xlsxData.concat(
                        this.tableArray.map((lineItem) => {
                            return this.tableHeader.map((header) => {
                                let itemVal = this.getValue(lineItem, header.value)

                                 // format date 
                                if (itemVal && ['createdAt', 'closedAt'].includes(header.value)) {
                                    const date = new Date(itemVal)
                                    itemVal = date.toLocaleDateString()                                   
                                }

                                // check advance exchange
                                if (itemVal && header.value == "rmaType") {
                                    const advanceEx = itemVal === 'GVS_ADVANCE_EXCHANGE' ? 'Yes' : 'No'
                                    itemVal = advanceEx
                                }
                                return itemVal
                            })
                        })
                    )
                    const wb = XLSX.utils.book_new()
                    const ws = XLSX.utils.aoa_to_sheet(xlsxData)
                    XLSX.utils.book_append_sheet(wb, ws, 'report')
                    XLSX.writeFile(wb, this.fileName)
                }

                this.loading = false
                this.$emit(`onSuccess`, 200)
            } catch (error) {
                alert(`Error Downloading File`)
                this.loading = false
                this.$emit(`onError`, 400)
            }
        }
    }
}
</script>

<style></style>